import { useEffect, useRef } from 'react';
import { handleSilentRenewCallback } from './utils/AuthService';

// FALLBACK ONLY. The hidden OIDC silent-renew iframe normally gets the standalone
// public/silent-renew.html (the server and the webpack dev server map /silent-renew to it),
// so this route no longer runs on a renewal. It stays because the server only rewrites when
// wwwroot/silent-renew.html exists; on a host without it this route still completes the
// callback, just after a full SPA boot. It must execute quickly and render nothing.
export default function SilentRenewCallback() {
  const ran = useRef(false);
  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    handleSilentRenewCallback();
  }, []);
  return null;
}
